import Splide from "@splidejs/splide";


const expeditionSlider = document.querySelector(".expedition__slider");

if (expeditionSlider) {
    console.log('ololoe')
  const spliderSettings = {
    type: "loop",
    // pagination: true,
    arrows: true,
    cover: true,
    breakpoints: {
      // 640: {
          heightRatio: 0.2,
      // },
    },
  };

  let splide = new Splide(expeditionSlider, spliderSettings)
  console.log(splide)
  splide.mount()


}
